import { Check, Minus, Plus, X } from "lucide-react";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { ScrollArea } from "../ui/scroll-area";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "../ui/sheet";
import { useLanguage } from "../../i18n/LanguageContext";

// Side sheet that shows the employee's current cart and submits the
// per-vendor purchase requests.
export default function RequestSheet({
  open,
  onOpenChange,
  user,
  lines,
  notes,
  onNotes,
  onInc,
  onDec,
  onRemove,
  onLineNote,
  onSubmit,
}) {
  const { t } = useLanguage();
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="w-full sm:max-w-md bg-[#F3EFE7] border-l border-[#E6E0D4] flex flex-col p-0">
        <SheetHeader className="px-5 pt-5">
          <SheetTitle className="font-serif-display text-2xl">{t("cartTitle")}</SheetTitle>
          <SheetDescription className="text-[#0B1F3A]/65">
            {t("cartHelp")}
          </SheetDescription>
        </SheetHeader>
        <ScrollArea className="flex-1 px-5">
          {lines.length === 0 ? (
            <div className="mt-10 text-center text-[#0B1F3A]/55 text-sm">{t("empty")}</div>
          ) : (
            <ul className="space-y-3 py-4">
              {lines.map(({ product, qty, note }) => (
                <li key={product.id} className="bg-white border border-[#E6E0D4] rounded-xl p-3">
                  <div className="flex items-start justify-between gap-3">
                    <div className="min-w-0">
                      <p className="text-[10px] tracking-eyebrow uppercase text-[#0B1F3A]/55">{product.category}</p>
                      <p className="text-sm font-medium leading-snug">{product.name}</p>
                    </div>
                    <button
                      onClick={() => onRemove(product.id)}
                      aria-label={t("remove")}
                      className="h-7 w-7 rounded-full hover:bg-[#F3EFE7] flex items-center justify-center text-[#0B1F3A]/60"
                    >
                      <X size={16} />
                    </button>
                  </div>
                  <div className="mt-3 flex items-center justify-between gap-3">
                    <div className="flex items-center gap-1 bg-[#F3EFE7] rounded-full p-1">
                      <button onClick={() => onDec(product.id)} className="h-7 w-7 rounded-full bg-white border border-[#E6E0D4] flex items-center justify-center"><Minus size={14} /></button>
                      <span className="min-w-8 text-center text-sm font-medium">{qty} {product.unit}</span>
                      <button onClick={() => onInc(product.id)} className="h-7 w-7 rounded-full bg-[#0B1F3A] text-white flex items-center justify-center"><Plus size={14} /></button>
                    </div>
                  </div>
                  <Textarea
                    placeholder={t("note")}
                    value={note}
                    onChange={(e) => onLineNote(product.id, e.target.value)}
                    className="mt-3 text-sm bg-[#FBF8F1] border-[#E6E0D4] min-h-[60px]"
                  />
                </li>
              ))}
            </ul>
          )}
        </ScrollArea>
        <div className="border-t border-[#E6E0D4] p-5 space-y-3 bg-white">
          <div>
            <label className="text-[10px] tracking-eyebrow uppercase text-[#0B1F3A]/55">{t("overall")}</label>
            <Textarea
              value={notes}
              onChange={(e) => onNotes(e.target.value)}
              placeholder={t("managerKnow")}
              className="mt-1 bg-white border-[#E6E0D4] min-h-[56px]"
            />
          </div>
          <Button
            onClick={onSubmit}
            disabled={lines.length === 0}
            className="w-full h-11 bg-[#0B1F3A] hover:bg-[#11294A] text-white disabled:opacity-50"
          >
            <Check size={16} className="mr-2" /> {t("send")}
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
